import Link from 'next/link.js';

import { ThemeTitle } from 'components/v1/ui/ThemeTitle';

const Startseite = () => {
  return (
    <div>
      <ThemeTitle text="Datenschutz" />
      <br></br>
      <p>
        Die Verantwortlichen dieses Online-Angebots haben ihren Sitz in der Schweiz. Die Benutzung dieser Website
        unterliegt Schweizer Recht. Die Bestimmungen der EU-DSGVO werden nur &quot;höchstvorsorglich&quot;
        berücksichtigt und lassen keinen Rückschluss darauf zu, dass wir der Anwendbarkeit der DSGVO oder allgemein
        EU-Recht unterliegen!{' '}
      </p>
      <br></br>
      <h4>Datenschutz ganz einfach:</h4>
      <p>
        1. Bei uns sind Ihre Daten sicher! Wir geben keine Daten an Dritte weiter.
        <br></br>
        2. Alle unsere Analyse-Werkzeuge anonymisieren Ihre IP-Adresse.
        <br></br>
        3. Bei einem Mausklick auf entsprechende Social-Media-Button wie YouTube, Facebook, Twitter, WhatsApp,
        GooglePlus werden Sie auf Webangebote geleitet, für die wir keine Verantwortung übernehmen können.
      </p>
      <br></br>
      <h4>Allgemeiner Hinweis und Pflichtinformationen</h4>
      <h5>
        <b>Benennung der verantwortlichen Stelle</b>
      </h5>
      <p>
        Verantwortlicher im Sinne der Datenschutz-Grundverordnung, sonstiger in den Mitgliedstaaten der Europäischen
        Union geltenden Datenschutzgesetze und anderer Bestimmungen mit datenschutzrechtlichem Charakter ist:
      </p>
      <p>
        Vetopedia
        <br />
        Hauptstr. 72
        <br />
        9430 St.Margrethen
        <br />
        Schweiz
        <br />
        Tel.: +41 (0)71 888 14 31
        <br />
        E-Mail: <a href="mailto:kontakt@vetopedia.ch">kontakt@vetopedia.ch</a>
        <br />
        Website: <Link href="/">https://www.vetopedia.ch/</Link>
      </p>
      <h6>
        <b>Verantwortlich für den Inhalt:</b>
      </h6>
      <p>Jeder Autor eines Video- oder Textbeitrages ist für den Inhalt seiner Publikation verantwortlich.</p>
      <p>
        <i>Kontaktperson:</i> Markus Knecht
      </p>
      <p>
        Die Kontaktperson entscheidet allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von
        personenbezogenen Daten (z.B. Namen, Kontaktdaten o. Ä.).
      </p>
      <h5>
        <b>Auskunftsrecht</b>
      </h5>
      <p>
        Sie können von dem Verantwortlichen eine Bestätigung darüber verlangen, ob personenbezogene Daten, die Sie
        betreffen, von uns verarbeitet werden.
      </p>
      <p>
        Liegt eine solche Verarbeitung vor, können Sie von dem Verantwortlichen über folgende Informationen Auskunft
        verlangen:
      </p>
      <ol>
        <li>die Zwecke, zu denen die personenbezogenen Daten verarbeitet werden;</li>
        <li>die Kategorien von personenbezogenen Daten, welche verarbeitet werden;</li>
        <li>
          die Empfänger bzw. die Kategorien von Empfängern, gegenüber denen die Sie betreffenden personenbezogenen Daten
          offengelegt wurden oder noch offengelegt werden;
        </li>
        <li>
          die geplante Dauer der Speicherung der Sie betreffenden personenbezogenen Daten oder, falls konkrete Angaben
          hierzu nicht möglich sind, Kriterien für die Festlegung der Speicherdauer;
        </li>
        <li>
          das Bestehen eines Rechts auf Berichtigung oder Löschung der Sie betreffenden personenbezogenen Daten, eines
          Rechts auf Einschränkung der Verarbeitung durch den Verantwortlichen oder eines Widerspruchsrechts gegen diese
          Verarbeitung;
        </li>
        <li>das Bestehen eines Beschwerderechts bei einer Aufsichtsbehörde;</li>
        <li>
          alle verfügbaren Informationen über die Herkunft der Daten, wenn die personenbezogenen Daten nicht bei der
          betroffenen Person erhoben werden;
        </li>
        <li>
          das Bestehen einer automatisierten Entscheidungsfindung einschließlich Profiling gemäß Art. 22 Abs. 1 und 4
          DSGVO und – zumindest in diesen Fällen – aussagekräftige Informationen über die involvierte Logik sowie die
          Tragweite und die angestrebten Auswirkungen einer derartigen Verarbeitung für die betroffene Person.
        </li>
      </ol>
      <p>
        Ihnen steht das Recht zu, Auskunft darüber zu verlangen, ob die Sie betreffenden personenbezogenen Daten in ein
        Drittland oder an eine internationale Organisation übermittelt werden. In diesem Zusammenhang können Sie
        verlangen, über die geeigneten Garantien gem. Art. 46 DSGVO im Zusammenhang mit der Übermittlung unterrichtet zu
        werden.
      </p>
      <h5>
        <b>Recht auf Berichtigung</b>
      </h5>
      <p>
        Sie haben ein Recht auf Berichtigung und/oder Vervollständigung gegenüber dem Verantwortlichen, sofern die
        verarbeiteten personenbezogenen Daten, die Sie betreffen, unrichtig oder unvollständig sind. Der Verantwortliche
        hat die Berichtigung unverzüglich vorzunehmen.
      </p>
      <div
        style={{
          border: '1px solid black',
          padding: '10px'
        }}
      >
        <h5>
          <b>Wiederspruchsrecht</b>
        </h5>

        <p>
          Sie haben das Recht, aus Gründen, die sich aus ihrer besonderen Situation ergeben, jederzeit gegen die
          Verarbeitung der Sie betreffenden personenbezogenen Daten, die aufgrund von Art. 6 Abs. 1 lit. e oder f DSGVO
          erfolgt, Widerspruch einzulegen; dies gilt auch für ein auf diese Bestimmungen gestütztes Profiling. Der
          Verantwortliche verarbeitet die Sie betreffenden personenbezogenen Daten nicht mehr, es sei denn, er kann
          zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die Ihre Interessen, Rechte und Freiheiten
          überwiegen, oder die Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.
          Werden die Sie betreffenden personenbezogenen Daten verarbeitet, um Direktwerbung zu betreiben, haben Sie das
          Recht, jederzeit Widerspruch gegen die Verarbeitung der Sie betreffenden personenbezogenen Daten zum Zwecke
          derartiger Werbung einzulegen; dies gilt auch für das Profiling, soweit es mit solcher Direktwerbung in
          Verbindung steht. Widersprechen Sie der Verarbeitung für Zwecke der Direktwerbung, so werden die Sie
          betreffenden personenbezogenen Daten nicht mehr für diese Zwecke verarbeitet. Sie haben die Möglichkeit, im
          Zusammenhang mit der Nutzung von Diensten der Informationsgesellschaft - ungeachtet der Richtlinie 2002/58/EG
          - Ihr Widerspruchsrecht mittels automatisierter Verfahren auszuüben, bei denen technische Spezifikationen
          verwendet werden.
        </p>
      </div>
      <br />
      <h5>
        <b>Widerruf Ihrer Einwilligung zur Datenverarbeitung</b>
      </h5>
      <p>
        Nur mit Ihrer ausdrücklichen Einwilligung sind einige Vorgänge der Datenverarbeitung möglich. Ein Widerruf Ihrer
        bereits erteilten Einwilligung ist jederzeit möglich. Für den Widerruf genügt eine formlose Mitteilung per
        E-Mail. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.{' '}
      </p>
      <h5>
        <b>Recht auf Löschung</b>
      </h5>
      <h6>
        <b>a. Löschungspflicht</b>
      </h6>
      <p>
        Sie können von dem Verantwortlichen verlangen, dass die Sie betreffenden personenbezogenen Daten unverzüglich
        gelöscht werden, und der Verantwortliche ist verpflichtet, diese Daten unverzüglich zu löschen, sofern einer der
        folgenden Gründe zutrifft:{' '}
      </p>
      <ol>
        <li>
          Die Sie betreffenden personenbezogenen Daten sind für die Zwecke, für die sie erhoben oder auf sonstige Weise
          verarbeitet wurden, nicht mehr notwendig.
        </li>
        <li>
          Sie widerrufen Ihre Einwilligung, auf die sich die Verarbeitung gem. Art. 6 Abs. 1 lit. a oder Art. 9 Abs. 2
          lit. a DSGVO stützte, und es fehlt an einer anderweitigen Rechtsgrundlage für die Verarbeitung.
        </li>
        <li>
          Sie legen gem. Art. 21 Abs. 1 DSGVO Widerspruch gegen die Verarbeitung ein und es liegen keine vorrangigen
          berechtigten Gründe für die Verarbeitung vor, oder Sie legen gem. Art. 21 Abs. 2 DSGVO Widerspruch gegen die
          Verarbeitung ein.
        </li>
        <li>Die Sie betreffenden personenbezogenen Daten wurden unrechtmäßig verarbeitet.</li>
        <li>
          Die Löschung der Sie betreffenden personenbezogenen Daten ist zur Erfüllung einer rechtlichen Verpflichtung
          nach dem Unionsrecht oder dem Recht der Mitgliedstaaten erforderlich, dem der Verantwortliche unterliegt.
        </li>
        <li>
          Die Sie betreffenden personenbezogenen Daten wurden in Bezug auf angebotene Dienste der
          Informationsgesellschaft gemäß Art. 8 Abs. 1 DSGVO erhoben.
        </li>
      </ol>
      <h6>
        <strong>b. Information an Dritte</strong>
      </h6>
      <p>
        Hat der Verantwortliche die Sie betreffenden personenbezogenen Daten öffentlich gemacht und ist er gem. Art. 17
        Abs. 1 DSGVO zu deren Löschung verpflichtet, so trifft er unter Berücksichtigung der verfügbaren Technologie und
        der Implementierungskosten angemessene Maßnahmen, auch technischer Art, um für die Datenverarbeitung
        Verantwortliche, die die personenbezogenen Daten verarbeiten, darüber zu informieren, dass Sie als betroffene
        Person von ihnen die Löschung aller Links zu diesen personenbezogenen Daten oder von Kopien oder Replikationen
        dieser personenbezogenen Daten verlangt haben.
      </p>

      <h6>
        <strong>c. Ausnahmen</strong>
      </h6>
      <p>Das Recht auf Löschung besteht nicht, soweit die Verarbeitung erforderlich ist.</p>
      <ol>
        <li>zur Ausübung des Rechts auf freie Meinungsäußerung und Information;</li>
        <li>
          zur Erfüllung einer rechtlichen Verpflichtung, die die Verarbeitung nach dem Recht der Union oder der
          Mitgliedstaaten, dem der Verantwortliche unterliegt, erfordert, oder zur Wahrnehmung einer Aufgabe, die im
          öffentlichen Interesse liegt oder in Ausübung öffentlicher Gewalt erfolgt, die dem Verantwortlichen übertragen
          wurde;
        </li>
        <li>
          aus Gründen des öffentlichen Interesses im Bereich der öffentlichen Gesundheit gemäß Art. 9 Abs. 2 lit. h und
          i sowie Art. 9 Abs. 3 DSGVO;
        </li>
        <li>
          für im öffentlichen Interesse liegende Archivzwecke, wissenschaftliche oder historische Forschungszwecke oder
          für statistische Zwecke gem. Art. 89 Abs. 1 DSGVO, soweit das unter Abschnitt a) genannte Recht
          voraussichtlich die Verwirklichung der Ziele dieser Verarbeitung unmöglich macht oder ernsthaft
          beeinträchtigt,
        </li>
        <li>oder zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.</li>
      </ol>
      <h5>
        <b>Recht auf Datenübertragbarkeit</b>
      </h5>
      <p>
        Ihnen steht das Recht zu, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags
        automatisiert verarbeiten, an sich oder an Dritte aushändigen zu lassen. Die Bereitstellung erfolgt in einem
        maschinenlesbaren Format. Sofern Sie die direkte Übertragung der Daten an einen anderen Verantwortlichen
        verlangen, erfolgt dies nur, soweit es technisch machbar ist.
      </p>
      <h5>
        <b>SSL- bzw. TLS-Verschlüsselung</b>
      </h5>
      <p>
        Aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, die Sie an uns als Seitenbetreiber
        senden, nutzt unsere Website eine SSL-bzw. TLS-Verschlüsselung. Damit sind Daten, die Sie über diese Website
        übermitteln, für Dritte nicht mitlesbar. Sie erkennen eine verschlüsselte Verbindung an der &quot;https://&quot;
        Adresszeile Ihres Browsers und am Schloss-Symbol in der Browserzeile.
      </p>
      <h5>
        <b>Server-Log-Dateien</b>
      </h5>
      <p>
        In Server-Log-Dateien erhebt und speichert der Provider der Website automatisch Informationen, die Ihr Browser
        automatisch an uns übermittelt. Dies sind:
      </p>
      <ul>
        <li>Browsertyp und Browserversion</li>
        <li>Verwendetes Betriebssystem</li>
        <li>Referrer URL</li>
        <li>Hostname des zugreifenden Rechners</li>
        <li>Uhrzeit der Serveranfrage</li>
        <li>IP-Adresse</li>
      </ul>
      <p>
        Es findet keine Zusammenführung dieser Daten mit anderen Datenquellen statt. Grundlage der Datenverarbeitung
        bildet Art. 6 Abs. 1 lit. b DSGVO, der die Verarbeitung von Daten zur Erfüllung eines Vertrags oder
        vorvertraglicher Maßnahmen gestattet. Diese Informationen werden nicht an Dritte weitergegeben und sind
        vorbeugende Maßnahmen (z.B. zur Aufklärung von Cyber-Kriminalität).
      </p>
      <h5>
        <b>Kontaktformular</b>
      </h5>
      <p>
        Per Kontaktformular übermittelte Daten werden einschließlich Ihrer Kontaktdaten gespeichert, um Ihre Anfrage
        bearbeiten zu können, oder um für Anschlussfragen bereitzustehen. Eine Weitergabe dieser Daten findet nicht
        statt. Die Verarbeitung der in das Kontaktformular eingegebenen Daten erfolgt ausschließlich auf Grundlage Ihrer
        Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Ein Widerruf Ihrer bereits erteilten Einwilligung ist jederzeit
        möglich. Für den Widerruf genügt eine formlose Mitteilung per E-Mail. Die Rechtmäßigkeit der bis zum Widerruf
        erfolgten Datenverarbeitungsvorgänge bleibt vom Widerruf unberührt. Über das Kontaktformular übermittelte Daten
        verbleiben bei uns, bis Sie uns zur Löschung auffordern oder Ihre Einwilligung zur Speicherung widerrufen. Zudem
        finden jährlich bei uns unter dem Gesichtspunkt der Datenminimierung Überprüfungen statt, in wiefern wir die
        übermittelten Daten noch zur Erfüllung der mit der Übermittlung verbundenen Zwecke benötigen. Alternativ ist
        eine Kontaktaufnahme über die bereitgestellte E-Mail-Adresse möglich. In diesem Fall werden die mit der E-Mail
        übermittelten personenbezogenen Daten des Nutzers gespeichert.
      </p>
      <h5>
        <b>Cookies</b>
      </h5>
      <p>
        Unsere Website verwendet Cookies. Das sind kleine Textdateien, die Ihr Webbrowser auf Ihrem Endgerät speichert.
        Cookies helfen uns dabei, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen. Einige Cookies
        sind &quot;Session-Cookies.&quot; Solche Cookies werden nach Ende Ihrer Browser-Sitzung von selbst gelöscht
        Hingegen bleiben andere Cookies auf Ihrem Endgerät bestehen, bis Sie diese selbst löschen. Solche Cookies helfen
        uns, Sie bei Rückkehr auf unserer Website wiederzuerkennen. Mit einem modernen Webbrowser können Sie das Setzen
        von Cookies überwachen, einschränken oder unterbinden. Viele Webbrowser lassen sich so konfigurieren, dass
        Cookies mit dem Schließen des Programms von selbst gelöscht werden. Die Deaktivierung von Cookies kann eine
        eingeschränkte Funktionalität unserer Website zur Folge haben. Das Setzen von Cookies, die zur Ausübung
        elektronischer Kommunikationsvorgänge oder der Bereitstellung bestimmter, von Ihnen erwünschter Funktionen (z.B.
        Warenkorb) notwendig sind, erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Als Betreiber dieser Website
        haben wir ein berechtigtes Interesse an der Speicherung von Cookies zur technisch fehlerfreien und reibungslosen
        Bereitstellung unserer Dienste. Sofern die Setzung anderer Cookies (z.B. für Analyse-Funktionen) erfolgt, werden
        diese in dieser Datenschutzerklärung separat behandelt.
      </p>
      <h5>
        <b>Matomo (ehemals Piwik)</b>
      </h5>
      <p>
        Unsere Website verwendet den Webanalysedienst Matomo. Matomo ist eine Open Source-Lösung. Matomo verwendet
        &quot;Cookies.&quot; Das sind kleine Textdateien, die Ihr Webbrowser auf Ihrem Endgerät speichert und die eine
        Analyse der Website-Benutzung ermöglichen. Mittels Cookie erzeugte Informationen über die Benutzung unserer
        Website werden auf unserem Server gespeichert. Vor der Speicherung erfolgt eine Anonymisierung Ihrer IP-Adresse.
        Cookies von Matomo verbleiben auf Ihrem Endgerät, bis Sie eine Löschung vornehmen. Das Setzen von Matomo-Cookies
        erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Als Betreiber dieser Website haben wir ein berechtigtes
        Interesse an der anonymisierten Analyse des Nutzerverhaltens, um sowohl unser Webangebot und ggf. auch Werbung
        zu optimieren. Es erfolgt keine Weitergabe der im Matomo-Cookie gespeicherten Informationen über die Benutzung
        dieser Website. Das Setzen von Cookies durch Ihren Webbrowser ist verhinderbar. Einige Funktionen unserer
        Website könnten dadurch jedoch eingeschränkt werden. Sie können hier die Speicherung und Nutzung Ihrer Daten
        deaktivieren. Ihr Browser setzt ein Opt-Out-Cookie, welches die Speicherung von Matomo Nutzungsdaten
        unterbindet. Wenn Sie Ihre Cookies löschen, wird auch das Matomo Opt-Out-Cookie entfernt. Bei einem erneuten
        Besuch unserer Website ist das Opt-Out-Cookie zur Unterbindung der Speicherung und Nutzung Ihrer Daten erneut zu
        setzen.
      </p>
      <iframe
        style={{
          border: '0',
          height: '200px',
          width: '600px'
        }}
        src='https://privacy.vetopedia.org/index.php?module=CoreAdminHome&action=optOut&backgroundColor=&fontColor=&fontSize=&fontFamily=system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
        title="matomo opt out"
      ></iframe>
    </div>
  );
};

export default Startseite;
